import styled from 'styled-components'

const H1 = styled.h1`
  grid-area: head;
`;

export default H1



// WEBPACK FOOTER //
// ./src/shared/H1.js